import { CSSObject } from "@mantine/core";
import { pxToRem } from "theme/spacing";

import { SizeVariant } from "./types";

export const sizeVariants: Record<SizeVariant, CSSObject> = {
  xxxl: {
    fontSize: pxToRem[48],
    lineHeight: pxToRem[64],
    letterSpacing: "-0.01em",
  },
  xxl: {
    fontSize: pxToRem[32],
    lineHeight: pxToRem[40],
    letterSpacing: "-0.01em",
  },
  xl: {
    fontSize: pxToRem[24],
    lineHeight: pxToRem[36],
    letterSpacing: "-0.01em",
  },
  lg: {
    fontSize: pxToRem[20],
    lineHeight: pxToRem[32],
    letterSpacing: "-0.01em",
  },
  md: {
    fontSize: pxToRem[16],
    lineHeight: pxToRem[24],
    letterSpacing: "0.01em",
  },
  base: {
    fontSize: pxToRem[14],
    lineHeight: pxToRem[20],
    letterSpacing: "0.01em",
  },
  sm: {
    fontSize: pxToRem[12],
    lineHeight: pxToRem[18],
    letterSpacing: "0.01em",
  },
} as const;
